if ( PRODUCTION ) {
  module.exports = require( './configureStore.prod' )
} else {
  module.exports = require( './configureStore.dev' )
}



/** WEBPACK FOOTER **
 ** ./src/app/redux/store/index.js
 **/